function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../saito-overlay/saito-overlay');
var SaitoCalendarEventTemplate = require('./saito-calendar-event-link.template.js');
var SaitoCalendarEvent = /*#__PURE__*/function () {
  function SaitoCalendarEvent(app, mod, event) {
    _classCallCheck(this, SaitoCalendarEvent);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
    this.event = event;
    this.interval = null;
  }
  return _createClass(SaitoCalendarEvent, [{
    key: "render",
    value: function render() {
      var _this = this;
      this.overlay.show(SaitoCalendarEventTemplate(this.app, this.event), function () {
        if (_this.interval) {
          clearInterval(_this.interval);
        }
      });
      window.history.pushState('', '', window.location.pathname);
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      this.updateButtonState();
      this.interval = setInterval(function () {
        return _this2.updateButtonState();
      }, 1000);
      var joinButton = document.getElementById('enter-call-button');
      if (joinButton) {
        joinButton.addEventListener('click', function () {
          _this2.app.keychain.addKey(_this2.event.publicKey, _this2.event);
          _this2.app.keychain.addWatchedPublicKey(_this2.event.publicKey);
          _this2.overlay.close();
          navigateWindow(_this2.event.link);
        });
      }
      var bookmark = document.getElementById('add-to-calendar');
      if (bookmark) {
        bookmark.onclick = function (e) {
          _this2.app.keychain.addKey(_this2.event.publicKey, _this2.event);
          _this2.app.keychain.addWatchedPublicKey(_this2.event.publicKey);
          _this2.overlay.close();
        };
      }
    }
  }, {
    key: "updateButtonState",
    value: function updateButtonState() {
      var joinButton = document.querySelector('.time-to-call');
      var now = new Date().getTime();
      var startTime_in_ms = new Date(this.event.startTime).getTime();
      console.log(now, startTime_in_ms);
      if (now < startTime_in_ms) {
        var timeLeft = this.getTimeLeft(now, startTime_in_ms);
        joinButton.textContent = "Call starts in ".concat(timeLeft);
      }
    }
  }, {
    key: "getTimeLeft",
    value: function getTimeLeft(now, start) {
      var diff = start - now;
      var hours = Math.floor(diff / (1000 * 60 * 60));
      var minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
      var seconds = Math.floor(diff % (1000 * 60) / 1000);
      return "".concat(hours.toString().padStart(2, '0'), ":").concat(minutes.toString().padStart(2, '0'), ":").concat(seconds.toString().padStart(2, '0'));
    }
  }]);
}();
module.exports = SaitoCalendarEvent;